import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { ConfigService } from 'src/app/services/config.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-share-study-mobile',
  templateUrl: './share-study-mobile.component.html',
  styleUrls: ['./share-study-mobile.component.css']
})
export class ShareStudyMobileComponent implements OnInit {

  opened: boolean = false;
  locator?: string;
  token?: string;

  showMail: boolean = false;
  showPhone: boolean = false;
  showQR: boolean = false;

  mail: string = '';

  urlBase: string = window.location.protocol+"//"+window.location.hostname+":"+window.location.port
  urlReadable : string =  (environment.demo) ? 'portal.memorial.com' : window.location.hostname+":"+window.location.port

  urlBook = window.location.href;

  environment = environment;

  @Output('sendMail') sendMailEmitter = new EventEmitter<string>();
  @Output('downloadReport') downloadEmitter = new EventEmitter<void>();

  constructor(private alertService: AlertService,
    public configService: ConfigService) { }


  ngOnInit(): void {

  }

  openModal(locator?: string) {
    this.mail = '';
    this.locator = locator;
    this.opened = true;
  }

  closeModal() {
    this.mail = '';
    this.showMail = false;
    this.showPhone = false;
    this.showQR = false;
    this.opened = false;
  }

  showPhoneInput() {
    if(this.showPhone == true){
      this.showPhone = false;
    }else{
      this.showPhone = true;
      this.showMail = false;
      this.showQR = false;
    }
    
  }

  showMailInput() {
    if(this.showMail == true){
      this.showMail = false;
    }else{
      this.showMail = true;
      this.showPhone = false;
      this.showQR = false;
    }
  }

  showQRImg(){
    if(this.showQR == true){
      this.showQR = false;
    }else{
      this.showQR = true;
      this.showPhone = false;
      this.showMail = false;
    }
  }

  sendMail() {
    if (this.mail == null || this.mail.trim() == '') {
      this.alertService.alert('Por favor, introduzca un correo electrónico');
    } else {
      this.sendMailEmitter.emit(this.mail);
      this.closeModal();
    }
  }

  downloadStudy(){
    this.downloadEmitter.emit();
    this.closeModal();
  }

}
